<template>
    <div ref="carousel" class="carousel">
        <div class="carousel-inner" :style="innerStyle">
            <div
                v-for="(image, index) in images"
                :key="index"
                class="carousel-item"
                :class="{ active: currentIndex === index }"
            >
                <img :src="image" :alt="`Preview ${index + 1}`" @error="handleImageError" />
            </div>
        </div>

        <button v-if="images.length > 1" class="carousel-control prev" @click="prev">❮</button>
        <button v-if="images.length > 1" class="carousel-control next" @click="next">❯</button>

        <div v-if="images.length > 1" class="carousel-indicators">
            <div
                v-for="(_, index) in images"
                :key="index"
                class="carousel-indicator"
                :class="{ active: currentIndex === index }"
                @click="goTo(index)"
            ></div>
        </div>
    </div>
</template>

<script>
    import { ref, computed } from 'vue'

    export default {
        props: {
            images: {
                type: Array,
                default: () => []
            }
        },
        setup(props) {
            const currentIndex = ref(0)

            const innerStyle = computed(() => ({
                transform: `translateX(-${currentIndex.value * 100}%)`
            }))

            function next() {
                currentIndex.value = (currentIndex.value + 1) % props.images.length
            }

            function prev() {
                currentIndex.value =
                    (currentIndex.value - 1 + props.images.length) % props.images.length
            }

            function goTo(index) {
                currentIndex.value = index
            }

            function handleImageError(event) {
                event.target.src = 'https://placehold.co/600x400?text=No+Preview'
            }

            return {
                currentIndex,
                innerStyle,
                next,
                prev,
                goTo,
                handleImageError
            }
        }
    }
</script>
